import { put, takeEvery, select } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { MICROACTIONS_PATH } from 'app/constants/navLinks.js'
import { getViewOrganizationId } from '../selectors'

import { createSprintForOrganization, updateSprintForOrganization } from '../actions'

export function* handleSaveOrganizationSprintSuccess() {
  const organizationId = yield select(getViewOrganizationId)
  yield put(push(`${MICROACTIONS_PATH}/organizations/${organizationId}/edit`))
}

export default function* takeEverySaveOrganizationSprintSuccess() {
  yield takeEvery(
    [createSprintForOrganization.success.toString(), updateSprintForOrganization.success.toString()],
    handleSaveOrganizationSprintSuccess
  )
}
